// CSS
import './ExactKeywordMatchesToggle.css';
// Skybase hooks
import { useQuery } from '../../context/QueryContext';
import { useData } from '../../context/DataContext';


// =========================
// ExactKeywordMatchesToggle – Controls the search intent for search query-processing.
// =========================
function ExactKeywordMatchesToggle({
    isSmall // bool: Is this component miniturized?
}){

    // Destructure global context
    const { isKeywordIntent, setIsKeywordIntent } = useQuery();
    const { isLoading }  = useData();

    // handleToggleClick()
    // ===================
    // Triggers this toggle IFF a search is NOT currently being processed
    const handleToggleClick = () => {
        if (!isLoading) { setIsKeywordIntent(!isKeywordIntent) };
    }
    
    // =============
    // JSX Component
    // =============
    return(
        <div className='SearchModeToggle-box'>
            
            {/* actual toggle */}
            <div className={`Search-mode-toggle ${isKeywordIntent ? "work-active" : ""} ${isLoading ? 'disabled-while-loading' : ''}`}>
                
                {/* Switch */}
                <span className="switch-indicator" />

                {/* Contextual mode button */}
                <button className={!isKeywordIntent ? "active" : ""} onClick={() => handleToggleClick()}>Intelligent</button>

                {/* Keyword mode button */}
                <button className={isKeywordIntent ? "active" : ""} onClick={() => handleToggleClick()}>Keyword</button>
            </div>

            {/* info text */}
            <div className='SearchModeToggle-info-text'>
                {isKeywordIntent
                    ? "Only find documents containing your exact search keyword."
                    : "Find all documents related to your search, even if they use different keywords." }
            </div>

        </div>
    );
};



// Export statement
export default ExactKeywordMatchesToggle;